import React from "react";

// Dummy observatory data - user will provide real data
export const observatoriesData = {
  title: "Sutter Observatories",
  description: (
    <>
      TransAstra operates a global network of Sutter™ telescope systems for space domain awareness and asteroid detection. Our observatories are strategically positioned around the world to provide continuous coverage of the sky, detecting and tracking objects from Low Earth Orbit to cislunar space and beyond.
    </>
  ),
  observatories: [
    {
      id: 1,
      name: "SkiesAway Remote Observatory",
      location: "Paso Robles, California",
      coordinates: { lat: 35.6295, lng: -120.6906 },
      status: "operational",
      telescopes: 6,
      description: "Primary West Coast observation site"
    },
    {
      id: 2,
      name: "Winer Observatory",
      location: "Tucson, Arizona",
      coordinates: { lat: 31.6736, lng: -110.6023 },
      status: "operational",
      telescopes: 4,
      description: "Desert observation site with excellent seeing conditions"
    },
    {
      id: 3,
      name: "Springbrook Remote Observatory Facilities",
      location: "Springbrook, Australia",
      coordinates: { lat: -28.2042, lng: 140.2695 },
      status: "operational",
      telescopes: 6,
      description: "Southern hemisphere observation site for complete sky coverage"
    },
    {
      id: 4,
      name: "E-Eye Observatory",
      location: "Spain",
      coordinates: { lat: 40.5128, lng: 0.760 }, // Spain
      status: "operational",
      telescopes: 6,
      description: "Planned fourth observatory site for enhanced network coverage"
    },
    {
        id: 5,
        name: "The Hive",
        location: "Los Angeles, California",
        coordinates: { lat: 34.0522, lng: -118.2437 }, // Los Angeles
        status: "operational",
        telescopes: 6,
        description: "Los Angeles test site for Sutter telescope systems"
      },
  ],
};

